/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSearchPresetRequest
 */
export interface CreateSearchPresetRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSearchPresetRequest
     */
    name: string;
    /**
     * 
     * @type {object}
     * @memberof CreateSearchPresetRequest
     */
    filters: object;
}

/**
 * Check if a given object implements the CreateSearchPresetRequest interface.
 */
export function instanceOfCreateSearchPresetRequest(value: object): value is CreateSearchPresetRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('filters' in value) || value['filters'] === undefined) return false;
    return true;
}

export function CreateSearchPresetRequestFromJSON(json: any): CreateSearchPresetRequest {
    return CreateSearchPresetRequestFromJSONTyped(json, false);
}

export function CreateSearchPresetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSearchPresetRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'filters': json['filters'],
    };
}

export function CreateSearchPresetRequestToJSON(json: any): CreateSearchPresetRequest {
    return CreateSearchPresetRequestToJSONTyped(json, false);
}

export function CreateSearchPresetRequestToJSONTyped(value?: CreateSearchPresetRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'filters': value['filters'],
    };
}

